(() => {
  const form = document.querySelector('form.lang-switcher');
  const selector = form?.querySelector('[data-country-selector]');

  if (!form || !selector || typeof window.Shopify === 'undefined') return;

  const ACTIVE_COUNTRY = (window.Shopify.country || selector.value || '').toUpperCase();
  const ROUTES_ROOT = window.Shopify.routes?.root || '/';
  const MANUAL_CHOICE_KEY = 'promosound_country_choice_v1';
  const SESSION_CHECK_KEY = 'promosound_country_check_v1';

  const storage = {
    get(store, key) {
      try {
        return store.getItem(key);
      } catch (error) {
        return null;
      }
    },
    set(store, key, value) {
      try {
        store.setItem(key, value);
      } catch (error) {
        // Localization still works when browser storage is unavailable.
      }
    },
  };

  selector.addEventListener('change', () => {
    storage.set(window.localStorage, MANUAL_CHOICE_KEY, selector.value.toUpperCase());
    form.requestSubmit();
  });

  if (window.Shopify.designMode) return;
  const manualChoice = (storage.get(window.localStorage, MANUAL_CHOICE_KEY) || '').toUpperCase();

  if (manualChoice) {
    const manualOption = Array.from(selector.options).find((item) => item.value.toUpperCase() === manualChoice);

    if (manualOption && manualChoice !== ACTIVE_COUNTRY) {
      selector.value = manualOption.value;
      form.requestSubmit();
    }

    return;
  }
  if (storage.get(window.sessionStorage, SESSION_CHECK_KEY)) return;

  storage.set(window.sessionStorage, SESSION_CHECK_KEY, 'pending');

  const suggestionsUrl = new URL(`${ROUTES_ROOT}browsing_context_suggestions.json`, window.location.origin);
  suggestionsUrl.searchParams.set('country[enabled]', 'true');
  suggestionsUrl.searchParams.set('country[exclude]', ACTIVE_COUNTRY);

  fetch(suggestionsUrl.toString(), {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Localization request failed: ${response.status}`);
      return response.json();
    })
    .then((payload) => {
      const countrySuggestion = payload?.suggestions?.find((suggestion) => suggestion?.parts?.country)?.parts?.country;
      const suggestedCountry = (countrySuggestion?.handle || '').toUpperCase();
      const confidence = Number(countrySuggestion?.confidence || 0);
      const option = Array.from(selector.options).find((item) => item.value.toUpperCase() === suggestedCountry);

      storage.set(window.sessionStorage, SESSION_CHECK_KEY, suggestedCountry || 'none');

      if (!option || suggestedCountry === ACTIVE_COUNTRY || confidence !== 1) return;

      selector.value = option.value;
      form.requestSubmit();
    })
    .catch(() => {
      storage.set(window.sessionStorage, SESSION_CHECK_KEY, 'failed');
    });
})();
